import { useNavigate } from "react-router-dom";
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Dialogs = ({
  t,
  showEndDialog,
  setShowEndDialog,
  handleEndConfirmed,
  showLoginPrompt,
  setShowLoginPrompt,
  showEarlyPitchersPrompt,
  setShowEarlyPitchersPrompt,
  pitchType,
  aiProfile,
}) => {
    const navigate = useNavigate();

  return (
    <>
      {/* Confirm END dialog */}
      <Dialog
        open={showEndDialog}
        onClose={() => setShowEndDialog(false)}
        PaperProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "white",
            px: 4,
            py: 3,
            borderRadius: 3,
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <HelpOutlineIcon sx={{ fontSize: 36, color: "#fff" }} />
          {t("confirm_end")}
        </DialogTitle>

        <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 2 }}>
          <Button
            onClick={() => {
              handleEndConfirmed();
              setShowEndDialog(false);
            }}
            sx={{
              color: "#9e9e9e",
              fontWeight: 600,
              "&:hover": {
                color: "#76ff03",
              },
            }}
          >
            {t("confirm_end_yes")}
          </Button>
          <Button
            onClick={() => setShowEndDialog(false)}
            sx={{
              color: "#d32f2f",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            {t("confirm_end_no")}
          </Button>

        </DialogActions>
      </Dialog>

      {/* Login required dialog */}
      <Dialog
        open={showLoginPrompt}
        onClose={() => setShowLoginPrompt(false)}
        PaperProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "white",
            mx: 2,
            px: 1,
            py: 3,
            borderRadius: 3,
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 36, color: "#fff" }} />
          {t("login_required_title")}
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center" }}>
          {t("login_required")}
        </DialogContent>

        <DialogActions
          sx={{
            flexDirection: "column",
            alignItems: "center",
            pb: 2,
            gap: 1.5,
          }}
        >
          {/* Fila: Iniciar sesión + Crear cuenta */}
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* INICIAR SESIÓN */}
            <Button
              onClick={() => {
                console.log("➡️ Redirigiendo al login...");
                navigate("/login", {
                  state: { from: "/pitch", pitchType, aiProfile },
                });
              }}
              sx={{
                color: "#76ff03",
                fontWeight: 600,
                "&:hover": { backgroundColor: "rgba(118,255,3,0.2)" },
              }}
            >
              {t("login_now")}
            </Button>

            {/* CREAR CUENTA */}
            <Button
              onClick={() => {
                console.log("➡️ Redirigiendo al signup...");
                navigate("/signup", {
                  state: { from: "/pitch", pitchType, aiProfile },
                });
              }}
              variant="outlined"
              sx={{
                color: "#b388ff",
                borderColor: "#b488ff9a",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(180, 136, 255, 0.22)",
                  borderColor: "#b388ff",
                },
              }}
            >
              {t("login_signup")}
            </Button>
          </Box>

          {/* Botón CANCELAR abajo */}
          <Button
            onClick={() => setShowLoginPrompt(false)}
            sx={{
              color: "#ffffffe4",
              fontWeight: 600,
              mt: 1,
              "&:hover": { color: "#f44336" },
            }}
          >
            {t("cancel")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Early Pitchers required dialog */}
      <Dialog
        open={showEarlyPitchersPrompt}
        onClose={() => setShowEarlyPitchersPrompt(false)}
        PaperProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "white",
            mx: 2,
            px: 2,
            py: 3,
            borderRadius: 3,
            maxWidth: 460,
            textAlign: "center",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 36, color: "#fff" }} />

          {/* Título */}
          <span style={{ fontSize: "1.25rem", fontWeight: 700 }}>
            {t("early_pitchers_title")}
          </span>
        </DialogTitle>

        <DialogContent
          sx={{
            textAlign: "center",
            fontSize: "0.95rem",
            opacity: 0.9,
            mt: 2,
          }}
        >
          <Box
            sx={{
              display: "inline-block",
              background: "rgba(113, 88, 226, 0.25)",  // violeta translúcido
              color: "#d0b3ff",                       // texto violeta claro
              px: 2,
              py: 0.5,
              borderRadius: "999px",
              fontSize: "0.85rem",
              fontWeight: 600,
              mb: 2,
            }}
          >
            {t("early_pitchers_subtitle")}
          </Box>

          {/* TEXTO PRINCIPAL */}
          <Box sx={{ mt: 1.5, mb: 1, mx: 0, px:1, fontSize: "1rem", lineHeight: 1.4 }}>
            {t("early_pitchers")}
          </Box>

        </DialogContent>

        <DialogActions
          sx={{
            flexDirection: "column",
            alignItems: "center",
            pb: 2,
            gap: 1.5,
            mt: 1,
          }}
        >
          {/* CTA: ir a Early Pitchers */}
        <Button
          onClick={() => {
            console.log("➡️ Redirigiendo a Early Pitchers...");
            navigate("/early-pitchers", {
              state: { from: "/pitch", pitchType, aiProfile },
            });
          }}
          variant="contained"
          fullWidth
          sx={{
            borderRadius: "999px",
            px: 4,
            py: 1.5,
            height: 48,
            fontWeight: 600,
            textTransform: "none",
            color: "#ffffff",
            background: "linear-gradient(to right, #5e35b1, #7e57c2)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
            "&:hover": {
              background: "linear-gradient(to right, #4527a0, #673ab7)",
            },
            width: "auto",  
            minWidth: "unset",
          }}
        >
          {t("early_pitchers_join")}
        </Button>

          {/* Más tarde / Cancelar */}
          <Button
            onClick={() => setShowEarlyPitchersPrompt(false)}
            sx={{
              color: "#ffffffe4",
              fontWeight: 600,
              "&:hover": { color: "#f44336" },
            }}
          >
            {t("early_pitchers_later")}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default Dialogs;
